export enum ApprovalFlowSubsystem {
Leaves,
Resignations,
}
